
import { defineComponent } from 'vue'
import { IAlertsStoreState, IStoreState } from '@/interfaces'
import { createNamespacedHelpers } from 'vuex'
import store from './store'
import { auth, companyNotificationsCollection } from './utilities'
import firebase from 'firebase'
import { AlertType } from '@/enums'
import { Alert } from '@/components'
import { INotificationModel, IUserModel, UserRole } from '@esse-group/shared'
// eslint-disable-next-line @typescript-eslint/no-var-requires
// const sound = require('@/assets/audio/notification.mp3')
// const audio = new Audio(sound)
// audio.pause()
const { mapState } = createNamespacedHelpers('alerts')
const authHelper = createNamespacedHelpers('auth')

export default defineComponent({
  name: 'App',

  components: {
    Alert
  },

  store: store,

  data: function () {
    return {
      companyNotificationsListener: undefined as any | undefined
    }
  },

  methods: {
    // Include the AuthenticationStore actions
    ...authHelper.mapActions(['bindAuthUser', 'bindUserDocument', 'unbindUserDocument']),

    listenCompanyNotifications: function () {
      this.companyNotificationsListener = companyNotificationsCollection
        .orderBy('createdTs', 'desc')
        .limit(15)
        .onSnapshot(
          { includeMetadataChanges: true },
          async (snapshot: firebase.firestore.QuerySnapshot<firebase.firestore.DocumentData>): Promise<void> => {
            console.log('Home - new notification', { snapshot })
            // eslint-disable-next-line eqeqeq
            if (snapshot.docs[0] != undefined && snapshot.docs[0].data() != undefined) {
              const last: INotificationModel = await snapshot.docs[0].data() as INotificationModel

              console.log('Home - last', { last })

              await this.$store.dispatch('alerts/create', { message: last.title, type: AlertType.info })
              //   audio.play()
              await this.$store.commit('companyNotifications/appendLastNotifications', { notification: last })
            }
          }
        )
    },
    unlistenCompanyNotifications: function () {
      if (this.companyNotificationsListener !== undefined) {
        this.companyNotificationsListener()
      }
    }
  },

  mounted () {
    // Bind and listen the Firebase Auth authentication status
    console.debug('AuthenticationStore - bindAuthUser')
    auth
      .onAuthStateChanged(async (authUser) => {
        console.debug('AuthenticationStore - bindAuthUser - received value', { authUser })
        if (authUser && typeof authUser === 'object') {
          this.$store.commit('auth/setAuthUser', authUser)
          this.listenCompanyNotifications()

          const user: IUserModel = await this.$store.dispatch('users/getUser', authUser.uid)
          console.debug('AuthenticationStore - bindAuthUser - user', { authUser, user })

          // eslint-disable-next-line eqeqeq
          if (user == undefined) {
            this.$store.commit('auth/setAuthUser', null)
            this.unlistenCompanyNotifications()
            this.unbindUserDocument()
            await auth.signOut()

            return
          }
          if (user.role < UserRole.ADMIN) {
            this.$store.commit('auth/setAuthUser', null)
            this.unlistenCompanyNotifications()
            this.unbindUserDocument()
            this.$router.replace({ name: 'Login' })
            await this.$store.dispatch('alerts/create', { message: 'Accesso non consetito', type: AlertType.error })
            await auth.signOut()

            return
          }

          this.bindUserDocument()

          // eslint-disable-next-line eqeqeq
          if (this.$route.query != undefined && this.$route.query.redirect != undefined) {
            this.$router.replace({ path: this.$route.query.redirect as string })
          } else {
            this.$router.replace({ name: 'Users' })
          }
        } else {
          this.$store.commit('auth/setAuthUser', null)
          this.unlistenCompanyNotifications()
          this.unbindUserDocument()
        }
      })
  },

  computed: {
    ...mapState<IAlertsStoreState>({
      alerts: (state: IStoreState) => state.alerts
    })
  },

  watch: {
    $route (to, from): void {
      console.log(`to ${to.name} - from ${from.name}`)
      // react to route changes...
    }
  }
})
